export default __webpack_public_path__ + "static/media/cain5.7842f765.jpg";